import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';
import { EmbeddedEditPageLoader } from '@confluence/embedded-confluence';
import { BannerContext } from '@confluence/banners';

import { ClassicEditorContextProviderLoader } from '../../ClassicEditorContextProvider';
import { navdexEnd } from '../naxdev';

const bannerContextValue = { includeTopNav: false };

export const EditPageEmbedRoute = ({
	params: { contentId, spaceKey },
	query: { draftShareId },
}) => {
	return (
		<Screen
			showPremiumOnboarding={false}
			screenEvent={{
				name: 'editPageEmbedScreen',
				id: contentId,
				...navdexEnd,
			}}
			pageState={{ contentId, spaceKey, contentType: 'page' }}
		>
			<BannerContext.Provider value={bannerContextValue}>
				<ClassicEditorContextProviderLoader>
					<EmbeddedEditPageLoader
						contentId={contentId}
						spaceKey={spaceKey}
						draftShareId={draftShareId}
						contentType="page"
					/>
				</ClassicEditorContextProviderLoader>
			</BannerContext.Provider>
		</Screen>
	);
};

EditPageEmbedRoute.propTypes = {
	params: PropTypes.shape({
		contentId: PropTypes.string,
		spaceKey: PropTypes.string,
	}),
	query: PropTypes.shape({
		draftShareId: PropTypes.string,
	}),
};
